import { LeadsState } from './state';
import { leadsInitialState } from './initial-state';
import { LeadsActions } from './action-creators';
import * as actions from './actions';

export const leadsReducer = (state: LeadsState = leadsInitialState, action: LeadsActions): LeadsState => {
  switch (action.type) {

    case actions.GET_LEADS_SUCCESS: {
      return {
        ...state,
        summary: action.summary
      }
    }

    case actions.RESET_LEADS: {
      return {};
    }

    default: {
      return { ...state };
    }
  }
}